import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { type UpdateAccountSolarSettingsInput } from '@/gql/graphql';

const UPDATE_ACCOUNT_SOLAR_SETTINGS = graphql(`
  mutation UpdateAccountSolarSettings(
    $input: UpdateAccountSolarSettingsInput!
  ) {
    updateAccountSolarSettings(input: $input) {
      ...AccountSolarSettingsFields
    }
  }
`);

const useUpdateAccountSolarSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (input: UpdateAccountSolarSettingsInput) =>
      gqlClient.request(UPDATE_ACCOUNT_SOLAR_SETTINGS, { input }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountSolarSettings(),
      });
      void queryClient.invalidateQueries({ queryKey: meKeys.restProfile() });
    },
  });
};

export default useUpdateAccountSolarSettings;
